import { useCallback, useEffect, useRef, useState } from "react";

// تخزين مؤقت عام (stale-while-revalidate): يعرض آخر بيانات محفوظة فورًا عند العودة للصفحة
// (بلا إطار تحميل ولا إعادة رسم)، ثم يحدّثها بهدوء في الخلفية. يزيل بطء "إعادة تحميل الإطار".
const CACHE = new Map();

export const useCachedResource = (key, fetcher, deps = []) => {
  const seeded = CACHE.has(key);
  const [data, setData] = useState(seeded ? CACHE.get(key) : undefined);
  const [loading, setLoading] = useState(!seeded);
  const [error, setError] = useState(null);
  const fnRef = useRef(fetcher);
  fnRef.current = fetcher;

  const reload = useCallback(async () => {
    if (!CACHE.has(key)) setLoading(true);
    try {
      const result = await fnRef.current();
      CACHE.set(key, result);
      setData(result);
      setError(null);
      return result;
    } catch (err) {
      setError(err);
      return undefined;
    } finally {
      setLoading(false);
    }
  }, [key]);

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, ...deps]);

  return { data, loading, error, reload, setData };
};

export const clearCachedResource = (key) => {
  if (key) CACHE.delete(key);
  else CACHE.clear();
};
